// import React from 'react';
// import { useLocation, useNavigate } from 'react-router-dom';
// import { Button, Card } from 'react-bootstrap';
// import Navbar from './Navbar'; // Adjust the path if necessary

// function BlogPage() {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const blogData = location.state?.blogData;

//   if (!blogData) {
//     return <div>Blog not found.</div>;
//   }

//   return (
//     <>
//       <Navbar />
//       <div className="blog-page container">
//         <h1 className="text-center">{blogData.title}</h1>
//         <p className="text-center">{blogData.description}</p>
//         <div className="row">
//           {blogData.blogs.map((blog) => (
//             <div className="col-md-4 mb-4" key={blog.id}>
//               <Card>
//                 <Card.Img variant="top" src={blog.Image1} alt={blog.Title} />
//                 <Card.Body>
//                   <Card.Title>{blog.Title}</Card.Title>
//                   <Card.Text>{blog.Name}</Card.Text>
//                 </Card.Body>
//               </Card>
//             </div>
//           ))}
//         </div>
//         <Button variant="secondary" onClick={() => navigate(-1)}>
//           Back
//         </Button>
//       </div>
//     </>
//   );
// }

// export default BlogPage;
// import React, { useEffect,useState } from 'react';
// import { useParams,useLocation, useNavigate } from 'react-router-dom';
// import { Button } from 'react-bootstrap';
// import Navbar from './Navbar'; // Adjust the path if necessary
// import { motion } from 'framer-motion';
// import {blogData} from '../components/Project';
// import { FaArrowLeft } from 'react-icons/fa';
// import Footer from '../components/Footer';



// function BlogPage() {
//   const { id } = useParams();
//   const [selectedBlog, setSelectedBlog] = useState(null);
//   const location = useLocation();
//   const navigate = useNavigate();
//   // const blogData = location.state?.blogData;
//   const [loading, setLoading] = useState(true);
//   // if (!blogData) {
//   //   return <div>Blog not found.</div>;
//   // }

//   // return (
//   //   <>
//   //     <Navbar />
//   //     <div className="blog-page container">
//   //       {/* Header Section */}
//   //       <div className="header-section text-center mb-5">
//   //         <h1 className="blog-title">{blogData.Title}</h1>
//   //         <p className="blog-description">{blogData.Description}</p>
//   //       </div>

//   //       {/* Blog Posts Section */}
//   //       <div className="blogs-feed">
//   //         {blogData.blogs.map((blog) => (
//   //           <div className="blog-item" key={blog.Id}>
//   //             <img
//   //               src={blog.Image1}
//   //               alt={blog.Title}
//   //               className="blog-image mb-3"
//   //             />
//   //             <h2 className="blog-item-title">{blog.Title}</h2>
//   //             <p className="blog-item-name">{blog.Name}</p>
//   //           </div>
//   //         ))}
//   //       </div>

//   //       {/* Back Button */}
//   //       <div className="text-center mt-4">
//   //         <Button variant="secondary" onClick={() => navigate(-1)}>
//   //           Back
//   //         </Button>
//   //       </div>
//   //     </div>
//   //   </>
//   // );
//  useEffect(() => {
//     const selectedCard = blogData.find((c) => c.id === parseInt(id));
//     setSelectedBlog(selectedCard || null);
//     setLoading(false);
//   }, [id]);

//   if (loading) {
//     return <div className="text-center mt-10 text-xl font-semibold">Loading...</div>;
//   }

//   if (!selectedBlog) {
//     return <div className="text-center mt-10 text-xl font-bold text-red-500">Blog not found.</div>;
//   }

//   return (
//     <>
//       <Navbar />
//       <motion.div
//         initial={{ opacity: 0 }}
//         animate={{ opacity: 1 }}
//         transition={{ duration: 1 }}
//         className="w-full min-h-screen bg-gray-100 p-10"
//       >
//         <h1 className="text-4xl font-bold text-center mb-10 text-gray-800">Latest Blogs</h1>
        
//         <div className="grid md:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-6 max-w-6xl mx-auto">
//           {blogData.map((blog) => (
//             <motion.div
//               key={blog.id}
//               whileHover={{ scale: 1.05 }}
//               transition={{ duration: 0.3 }}
//               className="bg-white shadow-lg rounded-xl overflow-hidden cursor-pointer"
//               onClick={() => setSelectedBlog(blog)}
//             >
//               <img src={blog.image} alt={blog.title} className="w-full h-56 object-cover" />
//               <div className="p-4">
//                 <h2 className="text-2xl font-semibold text-gray-800">{blog.title}</h2>
//                 <p className="text-gray-600 mt-2 line-clamp-3">{blog.description}</p>
//               </div>
//             </motion.div>
//           ))}
//         </div>
//       </motion.div>

//       {selectedBlog && (
//         <motion.div
//           initial={{ opacity: 0, y: 50 }}
//           animate={{ opacity: 1, y: 0 }}
//           exit={{ opacity: 0, y: 50 }}
//           className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center p-4"
//         >
//           <div className="bg-white max-w-2xl w-full p-6 rounded-lg relative">
//             <button
//               className="absolute top-4 right-4 text-gray-600 hover:text-gray-800"
//               onClick={() => setSelectedBlog(null)}
//             >
//               <FaArrowLeft size={24} />
//             </button>
//             <img src={selectedBlog.image} alt={selectedBlog.title} className="w-full h-64 object-cover rounded-lg" />
//             <h2 className="text-3xl font-bold text-gray-800 mt-4">{selectedBlog.title}</h2>
//             <p className="text-gray-600 mt-2 leading-relaxed">{selectedBlog.description}</p>
//           </div>
//         </motion.div>
//       )}
//       <Footer />
//     </>
//   );
// }

// export default BlogPage;

import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import Navbar from "./Navbar";
import Footer from "../components/Footer";
import { blogData } from "../components/Project";
import { FaArrowLeft } from "react-icons/fa";
import UpperPic1 from "../assets/ninthSection-pic1.jpg"
import UpperPic2 from "../assets/ninthSection-pic2.jpg"
import UpperPic3 from "../assets/ninthSection-pic3.jpg"
import { BsChatText } from 'react-icons/bs'
import '../css/blog.css';
import Blog from "./Blog";

function BlogPage() {
  const { id } = useParams();
  const [selectedBlog, setSelectedBlog] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const blog = blogData.find((b) => b.id === parseInt(id));
    setSelectedBlog(blog || null);
  }, [id]);

  if (!selectedBlog) {
    return (
      <div className="text-center mt-10 text-xl font-bold text-red-500">
        Blog not found.
      </div>
    );
  }

  return (
    <>
      <Navbar />

      {/* Hero Section */}
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          width: "100%",
          minHeight: "70vh",
          padding: "5vw",
          alignItems: "center",
          justifyContent: "center",
          background: "#f3f2f3",
          gap: "20px",
        }}
      >
      <motion.div
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
        style={{
          flex: "1",
          minWidth: "300px",
          maxWidth: "500px",
          textAlign: "center",
        }}
     >
        <h1   
        style={{
              fontSize: "clamp(2rem, 4vw, 3rem)",
              fontWeight: "bold",
              color: "#333",
            }}>{selectedBlog.title}</h1>
        <p className="text-lg text-gray-600 mt-4">{selectedBlog.description}</p>
      </motion.div>

      {/* Blog Content */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
        style={{
          flex: "1",
          minWidth: "300px",
          maxWidth: "550px",
          borderRadius: "12px",
          overflow: "hidden",
          boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
        }}
      >
        {/* Blog Image */}
        
          <img
            src={selectedBlog.image}
            alt={selectedBlog.title}
            style={{
              width: "100%",
              height: "auto",
              objectFit: "cover",
              borderRadius: "12px",
            }}
          />
           </motion.div>
          </div>
      

        {/* Blog Details */}
        <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.5, duration: 1 }}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  textAlign: "center",
                  width: "100%",
                  padding: "40px 5vw",
                }}
              >
                <h2
                  style={{
                    fontSize: "clamp(2rem, 3vw, 2.5rem)",
                    fontWeight: "bold",
                    color: "#333",
                    marginBottom: "15px",
                    textTransform: "uppercase",
                    letterSpacing: "1.5px",
                  }}
                >
                 Blog Details
                </h2>


          <p  className="text-gray-600"
          style={{
            maxWidth: "800px",
            fontSize: "clamp(1rem, 1.5vw, 1.2rem)",
            lineHeight: "1.8",
            color: "#555",
          }}>
            {selectedBlog.description.repeat(5)}
          </p>
          </motion.div>

        <Blog/>

      <Footer />
    </>
  );
}

export default BlogPage;
